// hero-slider.js — autoplay crossfade carousel with dot navigation.
const HeroSlider = {
	onReady() {
		document.querySelectorAll('.ax-hero').forEach((hero) => {
			const slides = Array.from(hero.querySelectorAll('.ax-hero__slide'));
			const dots = Array.from(hero.querySelectorAll('.ax-hero__dot'));
			if (slides.length < 2) {
				return;
			}

			const speed = parseInt(hero.getAttribute('data-autoplay-speed'), 10) || 7000;
			let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
			if (activeIndex === -1) {
				activeIndex = 0;
			}
			let timer = null;

			function goTo(index) {
				slides[activeIndex].classList.remove('is-active');
				if (dots[activeIndex]) {
					dots[activeIndex].classList.remove('is-active');
				}
				activeIndex = (index + slides.length) % slides.length;
				slides[activeIndex].classList.add('is-active');
				if (dots[activeIndex]) {
					dots[activeIndex].classList.add('is-active');
				}
			}

			function startAutoplay() {
				stopAutoplay();
				timer = window.setInterval(() => goTo(activeIndex + 1), speed);
			}

			function stopAutoplay() {
				if (timer) {
					window.clearInterval(timer);
					timer = null;
				}
			}

			dots.forEach((dot, index) => {
				dot.addEventListener('click', () => {
					goTo(index);
					startAutoplay();
				});
			});

			hero.addEventListener('mouseenter', stopAutoplay);
			hero.addEventListener('mouseleave', startAutoplay);

			startAutoplay();
		});

		document.querySelectorAll('.ax-hero__badges').forEach((widget) => {
			const track = widget.querySelector('.ax-hero__badges-track');
			const viewport = widget.querySelector('.ax-hero__badges-viewport');
			const prevBtn = widget.querySelector('[data-badges-prev]');
			const nextBtn = widget.querySelector('[data-badges-next]');
			let atBottom = false;

			function render() {
				const overflow = Math.max(0, track.scrollHeight - viewport.clientHeight);
				track.style.transform = `translateY(-${atBottom ? overflow : 0}px)`;
			}

			if (prevBtn) {
				prevBtn.addEventListener('click', () => {
					atBottom = false;
					render();
				});
			}

			if (nextBtn) {
				nextBtn.addEventListener('click', () => {
					atBottom = true;
					render();
				});
			}
		});
	},
};

export default HeroSlider;
